import { Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import XeroCallback from 'features/gap-components/xero-xpm-connect/XeroXpmCallback'
import RecallCalendarOAuthCallback from 'features/calendar/oauth-callback/RecallCalendarOAuthCallback'
import { OAuthRedirect } from 'auth/OAuthRedirect'
import OrgGuard from './org-guard/OrgGuard'

export default observer(
   function MainRouter() {
      return <Routes>
         <Route path="/">
            <Route index element={<OrgGuard />} />
            <Route path={'oauth-redirect'} element={<OAuthRedirect />} />
            <Route path={'xero-callback/*'} element={<XeroCallback />} />
            <Route path={'recall-calendar/oauth/callback'} element={<RecallCalendarOAuthCallback />} />
            <Route path={'org/:orgId/*'} element={<OrgGuard />} />
            <Route path="/*" element={<OrgGuard />} />
         </Route>
      </Routes>
   }
)
